import { render, staticRenderFns } from "./DebrisBoxConfig.vue?vue&type=template&id=b60548ee&scoped=true&"
import script from "./DebrisBoxConfig.vue?vue&type=script&lang=js&"
export * from "./DebrisBoxConfig.vue?vue&type=script&lang=js&"
import style0 from "./DebrisBoxConfig.vue?vue&type=style&index=0&id=b60548ee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b60548ee",
  null
  
)

export default component.exports